const config = {
    "baseURL": process.env.REACT_APP_BASE_URL,
    "redirectURL": process.env.REACT_APP_REDIRECT_URL
}

export const GOOGLE_AUTH_URL = process.env.REACT_APP_BASE_URL + '/oauth2/authorize/google?redirect_uri=' + process.env.REACT_APP_REDIRECT_URL;

export default config